/**
 * SupportQRContainer component.
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

const SupportQRContainer = styled.div`
  align-self: center;
  margin: ${48 * Screen.widthRatio}px 0;
`;

export default SupportQRContainer;
